import React, { useRef, useState } from "react";
import Icon from "./Icon";
import { uploadAudio } from "../api";
import { useI18n } from "../i18n";
import { C, R, S } from "../theme";

export default function VoiceNote({ onText }) {
  const { t: tr } = useI18n();
  const rec = useRef(null);
  const chunks = useRef([]);
  const [state, setState] = useState("idle"); // idle | recording | working
  const [err, setErr] = useState("");

  const supported = typeof window !== "undefined" && !!navigator.mediaDevices && !!window.MediaRecorder;
  if (!supported) return null;

  const start = async () => {
    setErr("");
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      chunks.current = [];
      const mr = new MediaRecorder(stream);
      mr.ondataavailable = (e) => chunks.current.push(e.data);
      mr.onstop = async () => {
        stream.getTracks().forEach((t) => t.stop());
        setState("working");
        try {
          const blob = new Blob(chunks.current, { type: "audio/webm" });
          const text = await uploadAudio(blob);
          if (text) onText(text);
        } catch (e) {
          setErr(tr("voice.failed"));
        } finally {
          setState("idle");
        }
      };
      rec.current = mr;
      mr.start();
      setState("recording");
    } catch {
      setErr(tr("voice.micUnavailable"));
    }
  };
  const stop = () => rec.current && rec.current.stop();

  return (
    <div>
      <button
        data-testid="voice-note-btn"
        className="pressable"
        onClick={state === "recording" ? stop : start}
        disabled={state === "working"}
        style={{
          display: "flex", alignItems: "center", justifyContent: "center", gap: S.sm,
          minHeight: 48, borderRadius: R.md, width: "100%",
          background: state === "recording" ? C.red : C.card2,
          border: `1px solid ${C.borderStrong}`, color: state === "recording" ? C.text : C.amber, fontWeight: 800,
        }}
      >
        <Icon name="mic" size={18} color={state === "recording" ? C.text : C.amber} />
        {state === "recording" ? tr("voice.stop") : state === "working" ? tr("voice.working") : tr("voice.record")}
      </button>
      {!!err && <div style={{ color: C.muted, fontSize: 12, marginTop: 4 }}>{err}</div>}
    </div>
  );
}
